'use client'

import dynamic from 'next/dynamic'

export const ErrorPage = dynamic(
  async () => {
    return (await import('@/modules/shared/ui/localComponents/Error'))
      .ErrorHandle
  },
  {
    ssr: false,
  },
)

export default function GlobalError() {
  return (
    <html>
      <body>
        <ErrorPage statusCode={500} />
      </body>
    </html>
  )
}
